import { RouterProvider } from 'react-router';

import { SessionProvider } from '@/features/auth/session';

import { router } from './router';

export function App() {
  return (
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  );
}
